import { Select as MUISelect } from '@mui/material';

/**
 * Project alias for MUI's Select. Import from here instead of `@mui/material`
 * so the whole app tracks one implementation. All MUI Select props pass
 * through.
 */
const Select = props => <MUISelect {...props} />;

export default Select;
